import React from 'react';
import { GoogleFilesPanel } from './GoogleFilesPanel';
import { Presentation } from 'lucide-react';
export function GoogleSlidesPanel() {
  return <GoogleFilesPanel title="Google Slides" description="Presentaciones, decks y material visual del equipo." mimeType="application/vnd.google-apps.presentation" icon={<Presentation size={24} data-id="element-4892" />} colorClass="text-amber-400" bgClass="bg-amber-500/10" borderClass="border-amber-500/20" glowClass="bg-amber-500/10" data-id="element-4891" />;
}